// extracted by mini-css-extract-plugin
module.exports = {"skipButton":"_3a9zyl","items":"_1Aily-","item":"_3yZXCk","modal":"Z167Gu"};